import { i18nNsFactory } from '@atlas-frontend/i18n';
import { path } from '../../paths';
import { UiLink } from '../../paths/UiLink';
import { useNavigateTo } from '../../paths/useNavigateTo';
import translations from './translations/OutputDataObjectDirectory.translations.json';
import { DataObjectView } from '@atlas-frontend/sdk';
import { DataObjectDirectory } from '../data-objects/DataObjectDirectory';
import { Helmet } from 'react-helmet-async';

const { addTranslations, useTranslation } = i18nNsFactory(
  'output-data-object-table'
);
addTranslations(translations);

export const OutputDataObjectDirectory = () => {
  const { t } = useTranslation();
  const navigateToOutputDataObjectCreate = useNavigateTo(
    path.outputDataObjectCreate
  );
  const navigateToOutputDataObjectView = useNavigateTo(
    path.outputDataObjectView
  );

  return (
    <>
      <Helmet>
        <title>{t('title.header')}</title>
      </Helmet>
      <DataObjectDirectory
        title={t('title.header')}
        view={DataObjectView.OUT}
        getRedirectAnchor={getRedirectAnchor}
        onClickCreate={navigateToOutputDataObjectCreate}
        onSelectVersion={(params: { id?: number }) =>
          params?.id
            ? navigateToOutputDataObjectView({ id: String(params.id) })
            : undefined
        }
      />
    </>
  );
};

const getRedirectAnchor = (versionId: number, value: string) => (
  <UiLink
    id={`dataObject-version-${versionId}`}
    path={path.outputDataObjectView}
    params={{ id: versionId }}
  >
    {value}
  </UiLink>
);
